export default __webpack_public_path__ + "media/zurb/img/services/services/data-driven-websites-img-464632d692ba335fd2d4bad424ed63f1.png";